import React, { useEffect, useState } from "react";
import { Dimensions, Platform, ScrollView, StyleSheet, TouchableOpacity, View, Image as Img } from "react-native";
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, LottieSizeTokens, LottieTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, } from "@voltmoney/schema";
import { ModalAlignmentEnum, SCREEN_SIZE } from '@voltmoney/types';
import { Header } from "../../header/Header";
import { isMobile } from "../../stack/utils";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Button } from "../../button/Button";
import { Space } from "../../space/Space";
import { Divider } from "../../divider/Divider";
import ThemeProvider from "@voltmoney/theme";
import Image from '../../image/Image';
import { addCommasToNumber } from "../utils";
import BottomSheet from "../BottomSheet";
import { Lottie } from "../../lottie/Lottie";
import TextField from "../TextField";
const Repayment = ({ height, stepperData, bankName, bankAccountNumber, ifscCode, principalLoanAmount, backPressAction, triggerAction, paymentAction, popupClosed, showError, disableButton, callFailureCase, repeatSameState }) => {
    const [upiDetailsVisible, setUpiDetailsVisible] = useState(false);
    const [netBankingVisible, setNetBankingVisible] = useState(false);
    const [enableButton, setEnableButton] = useState(false);
    const [upiId, setUpiId] = useState('');
    const [mode, setMode] = useState('');
    const [netBankingBottomCard, setNetBankingBottomCard] = useState(false);
    const [cancelPopup, setCancelPopup] = useState(true);
    const [inputError, setInputError] = useState(false);
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    useEffect(() => {
        return () => {
            setNetBankingBottomCard(false);
            if ((!cancelPopup) || (!netBankingVisible && !upiDetailsVisible)) {
                setNetBankingBottomCard(false);
            }
        };
    }, []);
    useEffect(() => {
        if (popupClosed) {
            setCancelPopup(true);
            setNetBankingBottomCard(false);
        }
    }, [popupClosed, repeatSameState]);
    useEffect(() => {
        if (!netBankingVisible && !upiDetailsVisible) {
            setEnableButton(false);
        }
    }, [netBankingVisible, upiDetailsVisible]);
    useEffect(() => {
        if (disableButton) {
            setEnableButton(false);
        }
        if (showError) {
            setInputError(true);
        }
        else {
            setInputError(false);
        }
    }, [disableButton, showError, callFailureCase]);
    const renderNetBankingCardView = () => {
        return (React.createElement(View, { style: styles.netBankingCardContainer },
            React.createElement(Lottie, { uri: LottieTokens.SandTimer, size: LottieSizeTokens.XL, autoplay: true, loop: true }),
            React.createElement(View, { style: styles.netBankingCardTitle },
                React.createElement(Typography, { label: "Taking you to net banking screen for completing payment", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: styles.netBankingCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'It may take few seconds', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.netBankingCardBottom },
                React.createElement(Typography, { label: 'Do not leave at this step', fontSize: FontSizeTokens.XXS, fontFamily: FontFamilyTokens.Inter, lineHeight: 18, fontWeight: "400", color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))));
    };
    const renderPopupCancelled = () => {
        return (React.createElement(View, { style: styles.netBankingCardContainer },
            React.createElement(Icon, { name: IconTokens.SystemError, size: IconSizeTokens.XXL }),
            React.createElement(View, { style: styles.netBankingCardTitle },
                React.createElement(Typography, { label: 'Payment Cancelled!', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24, textAlign: TextAlignTokens.center })),
            React.createElement(View, { style: styles.netBankingCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'Payment cancelled by the user. Please try again to complete the payment.', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, label: 'Try again', width: ButtonWidthTypeToken.FULL, onPress: () => {
                    setCancelPopup(false);
                }, fontSize: FontSizeTokens.SM })));
    };
    const renderNetBankingBottomCard = () => {
        return (React.createElement(View, { style: styles.netBankingBottomCard },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 262, width: '100%', alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: true }, renderNetBankingCardView())));
    };
    const validateUpi = (upiIdEntered) => {
        const re = /^[0-9A-Za-z.-]{2,256}@[A-Za-z]{2,64}$/;
        return re.test(upiIdEntered);
    };
    const renderPopUpCancelledBottomCard = () => {
        return (React.createElement(View, { style: styles.netBankingBottomCard },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 282, width: '100%', alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 504, routeId: "routeId", handleKeyboard: true }, renderPopupCancelled())));
    };
    return (React.createElement(View, { style: [
            styles.container,
            { height: height - 20 }
        ] },
        React.createElement(View, { style: styles.subContainer },
            React.createElement(View, { style: { width: '100%', paddingTop: Platform.OS === "ios" ? 4 : 0 } },
                React.createElement(Header, { type: HeaderTypeTokens.DEFAULT, stepperProps: stepperProps, isBackButton: true, title: "Paying Nuvama wealth", onPress: () => {
                        triggerAction({
                            ...backPressAction
                        });
                    } })),
            React.createElement(View, { style: {
                    padding: 16,
                    height: height - 70
                } },
                React.createElement(View, { style: styles.payableAmountContainer },
                    React.createElement(Typography, { fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: "500", lineHeight: 18, color: ColorTokens.Grey_Charcoal, label: 'Payable amount:' }),
                    React.createElement(View, { style: styles.marginTop2 },
                        React.createElement(Typography, { fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: '700', lineHeight: 24, color: ColorTokens.Grey_Night, label: `₹${addCommasToNumber(Math.trunc(Number(principalLoanAmount)))}` }))),
                React.createElement(View, { style: styles.marginTop16 },
                    React.createElement(Typography, { fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, fontWeight: "600", lineHeight: 24, color: ColorTokens.Grey_Night, label: 'Select payment method' })),
                React.createElement(ScrollView, { style: [styles.scrollViewContainer, { height: height - 160 }], scrollEnabled: true, showsVerticalScrollIndicator: false },
                    React.createElement(View, { style: styles.upiContainer },
                        React.createElement(TouchableOpacity, { onPress: () => {
                                setUpiDetailsVisible(!upiDetailsVisible);
                                setNetBankingVisible(false);
                                if (!netBankingVisible) {
                                    setEnableButton(false);
                                }
                                else {
                                    setEnableButton(true);
                                }
                                if (upiId.length > 0 && validateUpi(upiId)) {
                                    setEnableButton(true);
                                    setMode("UPI");
                                }
                                else {
                                    setEnableButton(false);
                                }
                            } },
                            React.createElement(View, { style: {
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                } },
                                React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/upi_icon.png" }, style: { width: 20, height: 20 } }),
                                React.createElement(View, { style: {
                                        marginLeft: 8
                                    } },
                                    React.createElement(Typography, { fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: "500", lineHeight: 24, color: ColorTokens.Grey_Night, label: `UPI` })),
                                React.createElement(View, { style: {
                                        justifyContent: 'flex-end',
                                        flex: 1,
                                        flexDirection: 'row'
                                    } }, upiDetailsVisible ?
                                    React.createElement(Icon, { name: IconTokens.UpBlackArrow, size: IconSizeTokens.XXL }) :
                                    React.createElement(Icon, { name: IconTokens.DownBlackArrow, size: IconSizeTokens.XXL })))),
                        upiDetailsVisible ?
                            (React.createElement(View, { style: {
                                    borderRadius: 8,
                                    borderWidth: 1,
                                    borderColor: "#E4E7EC",
                                    marginTop: 16,
                                    paddingBottom: 18
                                } },
                                React.createElement(View, { style: {
                                        borderTopLeftRadius: 8,
                                        borderTopRightRadius: 8,
                                        flexDirection: 'row',
                                        paddingVertical: 8,
                                        paddingHorizontal: 8,
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: "#FFF6DD",
                                    } },
                                    Platform.OS !== 'web' ?
                                        React.createElement(View, { style: {
                                                width: 20,
                                                height: 20,
                                                alignContent: 'center',
                                                alignItems: 'center',
                                                marginBottom: 4,
                                                marginLeft: 9,
                                            } },
                                            React.createElement(Image, { size: ImageSizeTokens.SIZE_22, uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/warning_image.png` }))
                                        :
                                            React.createElement(View, { style: {
                                                    width: 20,
                                                    height: 20,
                                                    marginRight: 12
                                                } },
                                                React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XS })),
                                    React.createElement(View, { style: {
                                            marginLeft: 12,
                                            alignContent: 'center',
                                            alignItems: 'center'
                                        } },
                                        React.createElement(Typography, { label: 'Enter the UPI ID linked to this account', fontSize: FontSizeTokens.XS, fontWeight: "600", lineHeight: 18, color: ColorTokens.Grey_Night }))),
                                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
                                React.createElement(View, { style: {
                                        padding: 16,
                                        flexDirection: 'row'
                                    } },
                                    React.createElement(View, { style: {
                                            flexDirection: 'column'
                                        } },
                                        React.createElement(Typography, { label: `${bankName}`, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: "400", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal }),
                                        React.createElement(Typography, { label: "XXXX " + bankAccountNumber.slice(-4), fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: "600", fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night })),
                                    React.createElement(View, { style: {
                                            justifyContent: 'flex-end',
                                            flex: 1,
                                            flexDirection: 'row',
                                            width: 42,
                                            height: 42
                                        } },
                                        React.createElement(Image, { uri: `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${ifscCode.substring(0, 4)}.png`, size: ImageSizeTokens.Size_40, borderRadius: BorderRadiusTokens.BR5 }))),
                                React.createElement(TextField, { style: { marginLeft: 16, marginRight: 16 }, value: upiId, focusColor: colorMapping[ColorTokens.Primary_100], label: "Enter UPI ID", holder: "Enter UPI ID", showError: inputError, errorText: 'Please enter a valid UPI ID', onBlur: () => {
                                        if (upiId.length > 0) {
                                            if (!validateUpi(upiId)) {
                                                setEnableButton(false);
                                                setInputError(true);
                                            }
                                            else {
                                                setInputError(false);
                                                setEnableButton(true);
                                            }
                                        }
                                    }, onFocus: () => {
                                        setInputError(false);
                                    }, onChangeText: (text) => {
                                        setInputError(false);
                                        setUpiId(text);
                                        if (text.length > 0) {
                                            setEnableButton(true);
                                        }
                                        else {
                                            setEnableButton(false);
                                        }
                                        setMode('UPI');
                                    } }))) : (React.createElement(React.Fragment, null))),
                    React.createElement(View, { style: {
                            marginTop: 8,
                            borderRadius: 8,
                            borderWidth: 1,
                            borderColor: "#E4E7EC",
                        } },
                        React.createElement(TouchableOpacity, { onPress: () => {
                                setNetBankingVisible(!netBankingVisible);
                                setUpiDetailsVisible(false);
                                if (netBankingVisible) {
                                    setEnableButton(false);
                                }
                                else {
                                    setEnableButton(true);
                                }
                                setMode('NET_BANKING');
                            } },
                            React.createElement(View, { style: {
                                    flexDirection: 'row',
                                    flex: 1,
                                    padding: 16,
                                    alignItems: 'center'
                                } },
                                React.createElement(Icon, { name: IconTokens.NetBanking, size: IconSizeTokens.XXL }),
                                React.createElement(View, { style: {
                                        marginLeft: 8
                                    } },
                                    React.createElement(Typography, { fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: "500", lineHeight: 24, color: ColorTokens.Grey_Night, label: 'Net banking' })),
                                React.createElement(View, { style: {
                                        justifyContent: 'flex-end',
                                        flex: 1,
                                        flexDirection: 'row'
                                    } }, netBankingVisible ?
                                    React.createElement(Icon, { name: IconTokens.UpBlackArrow, size: IconSizeTokens.XXL }) :
                                    React.createElement(Icon, { name: IconTokens.DownBlackArrow, size: IconSizeTokens.XXL })))),
                        netBankingVisible ?
                            React.createElement(View, { style: {
                                    borderColor: "#1434CB",
                                    borderWidth: 1,
                                    flexDirection: 'row',
                                    padding: 12,
                                    borderRadius: 8,
                                    marginLeft: 16,
                                    marginRight: 16,
                                    marginBottom: 16,
                                    backgroundColor: '#F3F5FC',
                                } },
                                React.createElement(View, { style: { flexDirection: 'row', flex: 1 } },
                                    React.createElement(View, { style: {
                                            flexDirection: 'row',
                                            justifyContent: 'flex-start',
                                            alignItems: 'center',
                                            alignContent: 'center',
                                            alignSelf: 'center',
                                            marginRight: 8
                                        } },
                                        React.createElement(Image, { uri: `https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${ifscCode.substring(0, 4)}.png`, size: ImageSizeTokens.SM, borderRadius: BorderRadiusTokens.BR5 })),
                                    React.createElement(View, { style: { flexDirection: 'column' } },
                                        React.createElement(Typography, { label: `${bankName}`, color: ColorTokens.Grey_Night, fontWeight: '400', fontSize: FontSizeTokens.MD, lineHeight: 24, fontFamily: FontFamilyTokens.Inter }),
                                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                                        React.createElement(Typography, { label: `XXXX ${bankAccountNumber.slice(-4)}`, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XS, fontWeight: '500', lineHeight: 18 }))))
                            : React.createElement(React.Fragment, null))))),
        React.createElement(View, { style: styles.bottomContainer },
            React.createElement(Button, { type: enableButton ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, label: mode === "UPI" ? `Verify & pay ₹${addCommasToNumber(Math.trunc(Number(principalLoanAmount)))}` : `Pay ₹${addCommasToNumber(Math.trunc(Number(principalLoanAmount)))}`, fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, onPress: () => {
                    if (mode === "NET_BANKING") {
                        setNetBankingBottomCard(true);
                    }
                    else {
                        setNetBankingBottomCard(false);
                    }
                    if (mode === "UPI") {
                        if (!validateUpi(upiId)) {
                            setInputError(true);
                        }
                    }
                    triggerAction({
                        ...paymentAction,
                        payload: {
                            value: `${mode}`,
                            amountSelected: `${principalLoanAmount}`,
                            upiId: `${upiId}`
                        }
                    });
                } }),
            React.createElement(View, { style: styles.securityView },
                React.createElement(Icon, { name: IconTokens.SecureIcon, size: IconSizeTokens.XS }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: 'Pay securely with Volt Money', fontSize: FontSizeTokens.XXS, fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Secondary_100, fontWeight: '500', lineHeight: 16 }))),
        netBankingBottomCard && mode === "NET_BANKING" && renderNetBankingBottomCard(),
        popupClosed && cancelPopup && renderPopUpCancelledBottomCard()));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 120,
        marginHorizontal: -16
    },
    subContainer: {
        flex: 1,
        marginTop: -16
    },
    payableAmountContainer: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderRadius: 8,
        marginTop: 16,
        borderWidth: 1,
        borderColor: "#E4E7EC",
        backgroundColor: "#F9FAFB"
    },
    marginTop2: {
        marginTop: 2
    },
    marginTop16: {
        marginTop: 16
    },
    scrollViewContainer: { flex: 1, paddingBottom: 80 },
    upiContainer: {
        marginTop: 12,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: "#E4E7EC",
        padding: 16
    },
    bottomContainer: {
        position: 'absolute',
        bottom: 0,
        padding: 16,
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderColor: '#F2F4F7',
        borderTopWidth: 0.5,
        shadowOpacity: 0.08,
        elevation: 10,
        backgroundColor: 'white',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowRadius: 5,
    },
    securityView: { flexDirection: 'row', marginTop: 8, paddingBottom: Platform.OS === "ios" ? 18 : 0 },
    netBankingCardContainer: {
        alignItems: "center", flex: 1, height: 260, padding: 16, alignContent: 'center'
    },
    netBankingCardLottie: { width: 70, height: 'auto' },
    netBankingCardTitle: { marginTop: 16 },
    netBankingCardDescription: { marginTop: 4, marginBottom: 16 },
    netBankingCardBottom: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: '#FFF6DD',
        alignContent: 'center',
        alignItems: 'center',
        height: 32,
        justifyContent: 'center',
    },
    netBankingBottomCard: { position: 'absolute', bottom: 0, paddingBottom: Platform.OS === "ios" ? 12 : 0 }
});
export default (Repayment);
